import { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchFeaturedLearningResources } from '@/service/api'
import { useLearningCategoryStore, useAssetRenewStore } from '@/stores'
import HomeIcon from './HomeIcon'

function formatDuration(seconds?: number): string {
  if (!seconds) return '暂无时长'
  const mins = Math.floor(seconds / 60)
  if (mins < 60) return `${mins}分钟`
  const hours = Math.floor(mins / 60)
  const remainingMins = mins % 60
  return remainingMins > 0 ? `${hours}小时${remainingMins}分` : `${hours}小时`
}

export default function CourseSection() {
  const [courses, setCourses] = useState<Api.Learning.ResourceResponse[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [activeIndex, setActiveIndex] = useState<number>(0)
  const fetchedRef = useRef(false)

  const { fetchCategories, getCategoryNameByCode } = useLearningCategoryStore()

  useEffect(() => {
    fetchCategories()
  }, [fetchCategories])

  useEffect(() => {
    if (fetchedRef.current) return
    fetchedRef.current = true

    setLoading(true)
    fetchFeaturedLearningResources()
      .then((res) => {
        setCourses(res || [])
      })
      .catch((err) => {
        console.error('获取首页精品学习资源失败', err)
        fetchedRef.current = false
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  const assetCache = useAssetRenewStore((state) => state.assetCache)

  // 监听推荐课程列表，自动收集课程封面并在必要时进行 OSS 资源续发
  useEffect(() => {
    if (!courses.length) return

    // 1. 集中将原接口拿到的最新 access_url 注册至 Store 缓存
    courses.forEach((c) => {
      const coverAssetId = c.cover_asset?.id || c.cover_asset_id
      if (!coverAssetId) return

      const assetIdStr = String(coverAssetId)
      const accessUrl = c.cover_asset?.access_url
      const accessExpires = c.cover_asset?.access_expires

      if (accessUrl) {
        useAssetRenewStore.getState().setAssetCacheItem(assetIdStr, accessUrl, accessExpires)
      }
    })

    const renewRequests: Api.Upload.RenewResourceAccessURLsItemRequest[] = []
    const singleAssetIds: string[] = []

    // 2. 收集需要处理的资源标识 (由 Store 全局过滤拦截未过期项)
    courses.forEach((c) => {
      const resourceId = String(c.id || '')
      const coverAssetId = c.cover_asset?.id || c.cover_asset_id

      if (resourceId && coverAssetId) {
        renewRequests.push({
          resource_type: 'LEARNING_RESOURCE',
          resource_id: resourceId,
          asset_ids: [String(coverAssetId)],
        })
      } else if (coverAssetId) {
        singleAssetIds.push(String(coverAssetId))
      }
    })

    if (renewRequests.length) {
      useAssetRenewStore.getState().renewBatchResources(renewRequests).catch(() => {})
    }

    singleAssetIds.forEach((assetId) => {
      useAssetRenewStore.getState().renewSingleAsset(assetId).catch(() => {})
    })
  }, [courses])


  return (
    <section className="home-course home-screen">
      <div className="home-course__content">
        {/* 顶部 AIGC 学习基地 Header 区域 */}
        <div className="mb-6">
          <div className="flex flex-col gap-5 mb-3">
            <div>
              <div className="flex items-center gap-2.5 mb-2">
                <h2 className="text-4xl xl:text-5xl 2xl:text-6xl font-black text-slate-900 tracking-tight flex items-center gap-2.5">
                  <span className="text-emerald-500 font-extrabold">AIGC</span>
                  <span>学习基地</span>
                </h2>
                <span className="text-emerald-400 font-bold text-3xl leading-none">✦</span>
              </div>
              <p className="text-slate-500 text-base xl:text-lg font-medium">
                灵搭有丰富优质免费的AIGC学习视频
              </p>
            </div>

            {/* 4 个微特征胶囊卡片（合适内边距 px-5） */}
            {/* <div className="flex flex-wrap items-center gap-3.5 pt-2">
              <div className="flex items-center gap-3 px-5 py-3 bg-white/90 backdrop-blur-md rounded-2xl border border-white/90 shadow-sm hover:shadow-md transition-all shrink-0">
                <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0">
                  <HomeIcon name="video" size={20} className="text-emerald-600" />
                </div>
                <div>
                  <div className="text-sm xl:text-base font-bold text-slate-800">优质课程</div>
                  <div className="text-xs text-slate-400">精选优质内容</div>
                </div>
              </div>

              <div className="flex items-center gap-3 px-5 py-3 bg-white/90 backdrop-blur-md rounded-2xl border border-white/90 shadow-sm hover:shadow-md transition-all shrink-0">
                <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0">
                  <HomeIcon name="layers" size={20} className="text-emerald-600" />
                </div>
                <div>
                  <div className="text-sm xl:text-base font-bold text-slate-800">系统学习</div>
                  <div className="text-xs text-slate-400">从入门到精通</div>
                </div>
              </div>

              <div className="flex items-center gap-3 px-5 py-3 bg-white/90 backdrop-blur-md rounded-2xl border border-white/90 shadow-sm hover:shadow-md transition-all shrink-0">
                <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0">
                  <HomeIcon name="award" size={20} className="text-emerald-600" />
                </div>
                <div>
                  <div className="text-sm xl:text-base font-bold text-slate-800">实战项目</div>
                  <div className="text-xs text-slate-400">学以致用</div>
                </div>
              </div>

              <div className="flex items-center gap-3 px-5 py-3 bg-white/90 backdrop-blur-md rounded-2xl border border-white/90 shadow-sm hover:shadow-md transition-all shrink-0">
                <div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center flex-shrink-0">
                  <HomeIcon name="gift" size={20} className="text-emerald-600" />
                </div>
                <div>
                  <div className="text-sm xl:text-base font-bold text-slate-800">免费资源</div>
                  <div className="text-xs text-slate-400">持续更新</div>
                </div>
              </div>
            </div> */}
          </div>

          {/* 精选推荐栏与查看全部（整体调大并保持充裕上间距） */}
          <div className="flex items-center justify-between mt-8 xl:mt-10 mb-4">
            <div className="flex items-center gap-3.5">
              <h3 className="text-xl xl:text-2xl font-bold text-slate-900 flex items-center gap-1.5">
                <span>精选推荐</span>
                <span className="text-emerald-400 font-bold text-lg">✦</span>
              </h3>
              <span className="text-xs xl:text-sm text-slate-400 font-medium">
                热门优质课程，助你快速提升技能
              </span>
            </div>

            <Link
              to="/courses"
              className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-white/80 hover:bg-white text-slate-600 hover:text-emerald-600 border border-slate-200/80 text-xs xl:text-sm transition-all shadow-sm font-medium"
            >
              <span>查看全部</span>
              <HomeIcon name="chevron-right" size={15} />
            </Link>
          </div>
        </div>

        {/* 4 个课程卡片网格（整体调大） */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 xl:gap-6 py-1">
          {loading ? (
            // 4 个骨架屏
            Array.from({ length: 4 }).map((_, index) => (
              <div
                key={index}
                className="bg-white/80 rounded-3xl border border-slate-200/80 p-4 animate-pulse flex flex-col min-h-[320px]"
              >
                <div className="w-full aspect-[16/9.5] bg-slate-200 rounded-2xl mb-3.5" />
                <div className="h-6 bg-slate-200 rounded w-3/4 mb-3" />
                <div className="flex justify-between items-center mb-3">
                  <div className="h-4 bg-slate-200 rounded w-1/3" />
                  <div className="h-4 bg-slate-200 rounded w-1/4" />
                </div>
                <div className="mt-auto pt-3 border-t border-slate-100 flex justify-between items-center">
                  <div className="h-4 bg-slate-200 rounded w-1/4" />
                  <div className="h-6 bg-slate-200 rounded w-1/5" />
                </div>
              </div>
            ))
          ) : courses.length > 0 ? (
            courses.slice(0, 4).map((course) => {
              const isVideo = course.resource_type === 'VIDEO'
              const difficultyText =
                course.difficulty === 'BEGINNER'
                  ? '入门'
                  : course.difficulty === 'INTERMEDIATE'
                    ? '进阶'
                    : course.difficulty === 'ADVANCED'
                      ? '高级'
                      : ''

              const typeText = isVideo ? '视频课' : '图文课'

              // 价格显示
              const isFree = course.access_mode === 'FREE' || !course.points_price
              const priceText = isFree ? '免费' : `${course.points_price} 积分`

              const coverAssetId = course.cover_asset?.id || course.cover_asset_id
              const coverUrl = (coverAssetId && assetCache[coverAssetId]?.url) || course.cover_asset?.access_url

              return (
                <Link
                  key={course.id}
                  to={`/courses/${course.id}`}
                  className="group relative flex flex-col bg-white hover:bg-white rounded-3xl border border-slate-200/70 hover:border-emerald-400/50 shadow-sm hover:shadow-xl hover:shadow-emerald-500/10 transition-all duration-300 overflow-hidden hover:-translate-y-1 p-3.5 xl:p-4"
                >
                  {/* 封面图容器 */}
                  <div className="relative aspect-[16/9.5] w-full overflow-hidden bg-slate-100 rounded-2xl flex-shrink-0 mb-3.5">
                    {coverUrl ? (
                      <img
                        src={coverUrl}
                        alt={course.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        loading="lazy"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-slate-900 to-slate-800 text-white p-4">
                        <div className="text-center">
                          <HomeIcon name={isVideo ? 'clapperboard' : 'book-open'} size={36} className="mx-auto mb-1.5 text-emerald-400" />
                          <span className="text-xs xl:text-sm text-slate-300 font-medium line-clamp-1">{course.title}</span>
                        </div>
                      </div>
                    )}

                    {/* 顶栏 Badge */}
                    <div className="absolute top-3 left-3 right-3 flex items-center justify-between pointer-events-none">
                      {difficultyText ? (
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded text-xs font-semibold bg-emerald-600 text-white shadow-sm">
                          {difficultyText}
                        </span>
                      ) : (
                        <span />
                      )}

                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-white/90 backdrop-blur-md text-slate-800 shadow-sm border border-slate-100">
                        {getCategoryNameByCode(course.category_code, typeText)}
                      </span>
                    </div>

                    {/* 悬浮播放 Icon */}
                    <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-slate-900/20 backdrop-blur-[2px]">
                      <span className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-emerald-500 text-white shadow-lg transform group-hover:scale-110 transition-transform duration-300">
                        <HomeIcon name="play" size={18} className="ml-0.5 fill-current" />
                      </span>
                    </div>
                  </div>

                  {/* 卡片主体内容 */}
                  <div className="flex-1 flex flex-col px-1 pb-1">
                    {/* 标题 */}
                    <h3 className="text-base xl:text-lg font-bold text-slate-800 line-clamp-1 mb-2 group-hover:text-emerald-600 transition-colors leading-snug">
                      {course.title}
                    </h3>

                    {/* 独立课时展示 (靠右对齐) */}
                    <div className="flex items-center justify-end text-xs xl:text-sm mb-3.5">
                      <span className="font-semibold text-slate-600 bg-slate-100 px-2 py-0.5 rounded-md shrink-0 text-xs">
                        {course.lesson_count ? `${course.lesson_count} 节课` : '0 节课'}
                      </span>
                    </div>

                    {/* 底部信息：时长 & 价格 */}
                    <div className="pt-3 border-t border-slate-100 flex items-center justify-between text-xs xl:text-sm mt-auto">
                      <span className="flex items-center gap-1.5 text-slate-500 text-xs xl:text-sm">
                        <HomeIcon name="clock-3" size={14} className="text-emerald-600" />
                        <span>{formatDuration(course.estimated_duration_seconds)}</span>
                      </span>

                      <span className={`font-extrabold ${isFree ? 'text-emerald-600 text-sm xl:text-base' : 'text-emerald-600 text-base xl:text-lg'}`}>
                        {priceText}
                      </span>
                    </div>
                  </div>
                </Link>
              )
            })
          ) : (
            <div className="col-span-full py-16 text-center text-slate-400 bg-white/60 rounded-2xl border border-slate-200/60">
              <HomeIcon name="book-open" size={36} className="mx-auto mb-2 text-slate-300" />
              <p className="text-sm xl:text-base">暂无课程数据</p>
            </div>
          )}
        </div>

        {/* 底部滑块指示器 (基于真实数据动态渲染) */}
        {!loading && courses.length > 1 && (
          <div className="flex items-center justify-center gap-2 mt-8">
            {courses.slice(0, 8).map((_, index) => {
              const isActive = index === activeIndex
              return (
                <button
                  key={index}
                  type="button"
                  aria-label={`切换至第 ${index + 1} 项`}
                  onClick={() => setActiveIndex(index)}
                  className={`transition-all duration-300 ${isActive
                    ? 'w-5 h-2 bg-emerald-500 rounded-full'
                    : 'w-2 h-2 bg-slate-300/80 hover:bg-slate-400 rounded-full'
                    }`}
                />
              )
            })}
          </div>
        )}
      </div>
    </section>
  )
}
